import { render, staticRenderFns } from "./SetsRateModal.vue?vue&type=template&id=3e3aba64&scoped=true&"
import script from "./SetsRateModal.vue?vue&type=script&lang=js&"
export * from "./SetsRateModal.vue?vue&type=script&lang=js&"
import style0 from "./SetsRateModal.vue?vue&type=style&index=0&id=3e3aba64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3aba64",
  null
  
)

export default component.exports